<div class="export-download-menu-wrapper">
    <ng-container *ngIf="skipFormatPicker; else formatDropdown">
        <div class="export-download-menu-wrapper__direct">
            <button
                type="button"
                [ngClass]="['inline-flex', 'items-center', 'gap-2', buttonClass]"
                [attr.aria-label]="ariaLabel"
                (click)="emitImmediateDownload()"
            >
                <img
                    *ngIf="resolvedIconSrc"
                    [src]="resolvedIconSrc"
                    alt=""
                    class="w-4 h-4 shrink-0"
                />
                {{ label }}
            </button>

            <vsf-dropdown
                *ngIf="showShareLink"
                #shareDropdown
                [position]="dropdownPosition"
            >
                <button
                    vsfDropdownTrigger
                    type="button"
                    [ngClass]="['inline-flex', 'items-center', buttonClass]"
                    aria-label="More export options"
                    aria-haspopup="true"
                >
                    <img src="assets/icons/chevron-down.svg" alt="" class="w-3 h-3" />
                </button>
                <div vsfDropdownContent class="export-download-menu">
                    <button
                        type="button"
                        class="export-download-menu__option"
                        (click)="copyShareLink(shareDropdown)"
                    >
                        {{ shareLinkLabel }}
                    </button>
                </div>
            </vsf-dropdown>
        </div>
    </ng-container>

    <ng-template #formatDropdown>
        <vsf-dropdown
            #dropdown
            [position]="dropdownPosition"
            [matchTriggerWidth]="true"
        >
            <button
                vsfDropdownTrigger
                type="button"
                [ngClass]="['inline-flex', 'items-center', 'gap-2', buttonClass]"
                [attr.aria-label]="ariaLabel"
                [attr.aria-haspopup]="true"
            >
                <img
                    *ngIf="resolvedIconSrc"
                    [src]="resolvedIconSrc"
                    alt=""
                    class="w-4 h-4 shrink-0"
                />
                {{ label }}
            </button>

            <div vsfDropdownContent class="export-download-menu">
                <button
                    *ngFor="let option of menuOptions"
                    type="button"
                    class="export-download-menu__option"
                    (click)="selectFormat(option.value, dropdown)"
                >
                    {{ option.label }}
                </button>
                <ng-container *ngIf="showShareLink">
                    <div class="h-px my-1 bg-gray-200" role="separator"></div>
                    <button
                        type="button"
                        class="export-download-menu__option"
                        (click)="copyShareLink(dropdown)"
                    >
                        {{ shareLinkLabel }}
                    </button>
                </ng-container>
            </div>
        </vsf-dropdown>
    </ng-template>
</div>
